import React from "react";

const SingleFaq = (props) => {
  return (
    <div className="single-faq-holder">
      <div className="row align-items-center">
        <div className="col-12">
          <h4 className="faq-title">{props.title}</h4>
          <div className="faq-content">
            <ul>
              {props.content.map((data, index) => (
                <li key={index}>{data}</li>
              ))}
            </ul>
            {Boolean(props.extra) && (
              <div className="extra mt-4">{props.extra}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleFaq;
